import { Controller } from 'stimulus';

// Drawer editor for an announcement. Toggles the schedule datetime field, the
// company picker, and paints the selected category chip with its soft colour.
export default class extends Controller {
  static targets = ['scheduleField', 'companyList', 'companySearch', 'companyItems', 'companyEmpty', 'inForceFilter', 'selectAll', 'categoryGroup', 'viewTrackingField', 'bannerPositionField'];

  connect() {
    this.toggleSchedule();
    this.toggleDisplayMode();
    this.toggleAudience();
    this.paintCategories();
    if (this.hasCompanyItemsTarget) this.filterCompanies();
  }

  toggleSchedule() {
    const status = this.checkedValue('status');
    if (this.hasScheduleFieldTarget) this.scheduleFieldTarget.classList.toggle('hidden', status !== 'scheduled');
  }

  // View tracking only matters for the toast; the banner position only for the banner.
  toggleDisplayMode() {
    const displayMode = this.checkedValue('display_mode');
    if (this.hasViewTrackingFieldTarget) this.viewTrackingFieldTarget.classList.toggle('hidden', displayMode !== 'toastr');
    if (this.hasBannerPositionFieldTarget) this.bannerPositionFieldTarget.classList.toggle('hidden', displayMode !== 'banner');
  }

  toggleAudience() {
    const audience = this.checkedValue('audience_type');
    if (this.hasCompanyListTarget) this.companyListTarget.classList.toggle('hidden', audience !== 'selected');
  }

  // Filters the company checkboxes by the search term (matches the company name)
  // and, when the in-force filter is on, hides non-paying (not in_force) companies.
  filterCompanies() {
    const term = this.companySearchTarget.value.trim().toLowerCase();
    const onlyInForce = this.hasInForceFilterTarget && this.inForceFilterTarget.checked;
    let visibleCount = 0;
    this.companyItemsTarget.querySelectorAll('[data-company-name]').forEach((label) => {
      const checkbox = label.querySelector('input[type="checkbox"]');
      const matchesTerm = label.dataset.companyName.includes(term);
      // Keep already-selected companies visible even when they are no longer in force.
      const matchesInForce = !onlyInForce || label.dataset.inForce === 'true' || (checkbox && checkbox.checked);
      const visible = matchesTerm && matchesInForce;
      label.classList.toggle('hidden', !visible);
      if (visible) visibleCount += 1;
    });
    if (this.hasCompanyEmptyTarget) this.companyEmptyTarget.classList.toggle('hidden', visibleCount > 0);
  }

  // Checks/unchecks every currently visible company, honouring the active filters.
  toggleSelectAll() {
    const checked = this.selectAllTarget.checked;
    this.companyItemsTarget.querySelectorAll('[data-company-name]').forEach((label) => {
      if (label.classList.contains('hidden')) return;
      const checkbox = label.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = checked;
    });
  }

  paintCategories() {
    if (!this.hasCategoryGroupTarget) return;
    this.categoryGroupTarget.querySelectorAll('input[type=radio]').forEach((input) => {
      const chip = input.nextElementSibling;
      if (input.checked) {
        chip.style.background = chip.dataset.soft;
        chip.style.color = chip.style.getPropertyValue('--c');
      } else {
        chip.style.background = '';
        chip.style.color = '';
      }
    });
  }

  checkedValue(field) {
    const checked = this.element.querySelector(`input[name="announcement[${field}]"]:checked`);
    return checked ? checked.value : null;
  }
}
